__turbopack_context__.v({
  "calendarHeaderControl": "index-module__nYYhya__calendarHeaderControl",
  "calendarHeaderLevel": "index-module__nYYhya__calendarHeaderLevel",
  "currentDay": "index-module__nYYhya__currentDay",
  "day": "index-module__nYYhya__day",
  "decadeLabel": "index-module__nYYhya__decadeLabel",
  "error": "index-module__nYYhya__error" + " " + __turbopack_context__.i(367887)["error"],
  "input": "index-module__nYYhya__input" + " " + __turbopack_context__.i(367887)["input"],
  "label": "index-module__nYYhya__label" + " " + __turbopack_context__.i(367887)["label"],
  "monthYearLabel": "index-module__nYYhya__monthYearLabel",
  "monthsListControl": "index-module__nYYhya__monthsListControl",
  "placeholder": "index-module__nYYhya__placeholder",
  "root": "index-module__nYYhya__root" + " " + __turbopack_context__.i(367887)["root"],
  "section": "index-module__nYYhya__section",
  "weekday": "index-module__nYYhya__weekday",
  "yearsListControl": "index-module__nYYhya__yearsListControl",
});
